import services from '@/config/services'

export default class ModuloRidFattureClientiService{
  
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management`
  }

  async getAllRidInScadenza(opts = {}){
    let items = []
    let totalItems = 0

    if(!Object.keys(opts).length){
      opts = 'no-filters'
    }

    const url = `${this.baseUrl}/clienti/fatture/rid/in-scadenza/search`
    
    try {
      let res = await this.http.post(url, {filters: opts})
      res = res.data

      items = res.data
      totalItems = res.meta.total_items
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {
        items,
        total: totalItems,
      }
    }
  }

  async downloadXml(banca, flusso, filters){
    const url = `${this.baseUrl}/clienti/fatture/rid/${banca}/${flusso}/in-scadenza/xml`
  
    let httpConfig = {
      url,
      method: 'POST',
      data: {
        filters,
      },
      responseType: 'blob',
    }
    if(!('fattura_vendita.numeri' in filters)){
      httpConfig = {
        url,
        method: 'GET',
        responseType: 'blob',
      }
    }

    try {
      const res = await this.http(httpConfig)
      
      const blob = new Blob([res.data], {type: 'application/xml'});
      const fileName= window.decodeURI(res.headers['content-disposition'].split('=')[1], "UTF-8").split('"').join('')
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async uploadFileXml(file){
    let success = false

    const url = `${this.baseUrl}/clienti/fatture/rid`

    try {
      const formData = new FormData()
      formData.append('file', file)

      const settings = { 
        headers: { 
          'content-type': 'multipart/form-data' 
        } 
      }

      let res = await this.http.post(url, formData,  settings)

      res = res.data
      success = res.data
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return success
    }
  }

  async uploadFileStorniRid(file, bank){
    let items = []

    const url = `${this.baseUrl}/storni-rid/${bank}`

    try {
      const formData = new FormData()
      formData.append('file', file)

      const settings = { 
        headers: { 
          'content-type': 'multipart/form-data' 
        } 
      }

      await this.http.post(url, formData,  settings)
      .then(res => {        
        items = res.data
      })
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {items}
    }
  }
  async confirmImportStorniRid(data){
    let items = []

    const url = `${this.baseUrl}/conferma-storni-rid`
    
    try {
      await this.http.post(url, data)
      .then(res => {        
        items = res.data
      })
    } catch (err) {
      this.eventBus.emit('data-load-error', {message: err, url})
    } finally {
      this.eventBus.emit('data-loaded')
      
      // eslint-disable-next-line no-unsafe-finally
      return {items}
    }
  }

}
